import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from '@fluentui/react-components';

interface DeleteConfirmationDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isConfirming?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}

const DeleteConfirmationDialog = ({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  isConfirming = false,
  onConfirm,
  onCancel,
  children,
}: DeleteConfirmationDialogProps): JSX.Element => (
  <Dialog
    open={open}
    onOpenChange={(_, data) => {
      if (!data.open) {
        onCancel();
      }
    }}
    modalType="alert"
  >
    <DialogSurface style={{ maxWidth: '450px' }}>
      <DialogBody>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <p>{message}</p>
          {children}
        </DialogContent>
        <DialogActions>
          <Button appearance="primary" disabled={isConfirming} onClick={onConfirm}>
            {confirmLabel}
          </Button>
          <Button disabled={isConfirming} onClick={onCancel}>
            {cancelLabel}
          </Button>
        </DialogActions>
      </DialogBody>
    </DialogSurface>
  </Dialog>
);

export default DeleteConfirmationDialog;
